module.exports = __webpack_public_path__ + "img/customer-test.67718f32.jpg";